// extracted by mini-css-extract-plugin
export var arrow = "_2j-6";
export var changeItem = "_2j-3";
export var changesHeader = "_2j-1";
export var changesList = "_2j-2";
export var container = "_2j-0";
export var pathLabel = "_2j-4";
export var value = "_2j-7";
export var valuesContainer = "_2j-5";